/**
 * watch-subject-context-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tsmith@safetyweb.org>
 */

import { ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

// TODO: make self-verifying
export class WatchSubjectContextRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_WATCH_SUBJECT_CONTEXT;
	public static tag : MessageTag = MessageTag.REQ_WATCH_SUBJECT_CONTEXT;

  public originListId? : number;

  constructor (
    public objectId : number,
    public watchObjectId : number,
    originListId? : number
  ) {
    super();
    if (originListId !== undefined) {
      this.originListId = originListId;
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/watchlists/watch-subject-context-request.ts